import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home-feed" }
const _hoisted_2 = { class: "home-feed__inner" }
const _hoisted_3 = {
  key: 0,
  class: "home-feed__list"
}
const _hoisted_4 = {
  key: 1,
  class: "home-feed__empty"
}
const _hoisted_5 = {
  ref: "sentinel",
  class: "home-feed__sentinel",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 2,
  class: "home-feed__status"
}
const _hoisted_7 = {
  key: 3,
  class: "home-feed__status home-feed__status--error"
}
const _hoisted_8 = {
  key: 4,
  class: "home-feed__status"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HomeProductCard = _resolveComponent("HomeProductCard")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "home-feed__head" }, [
        _createElementVNode("h2", { class: "home-feed__title" }, "Latest Products")
      ], -1 /* CACHED */)),
      (_ctx.products.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createBlock(_component_HomeProductCard, {
                key: product.id,
                product: product
              }, null, 8 /* PROPS */, ["product"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "No products published yet."))
          : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_5, null, 512 /* NEED_PATCH */),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Loading more products…"))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.error) + " ", 1 /* TEXT */),
              _createElementVNode("button", {
                type: "button",
                class: "home-feed__retry",
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
              }, "Try again")
            ]))
          : (!_ctx.hasMore && _ctx.products.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "You're all caught up."))
            : _createCommentVNode("v-if", true)
    ])
  ]))
}